import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.29289 7.29289C1.68342 6.90237 2.31658 6.90237 2.70711 7.29289L12 16.5858L21.2929 7.29289C21.6834 6.90237 22.3166 6.90237 22.7071 7.29289C23.0976 7.68342 23.0976 8.31658 22.7071 8.70711L12.7071 18.7071C12.3166 19.0976 11.6834 19.0976 11.2929 18.7071L1.29289 8.70711C0.902369 8.31658 0.902369 7.68342 1.29289 7.29289Z"
  }));
});
var NavigationChevronDown = AbstractIcon.withComponent(Icon);
NavigationChevronDown.displayName = 'NavigationChevronDown';
export default NavigationChevronDown;